export const PASSWORD_MIN_LENGTH = 15;
export const PASSWORD_MAX_LENGTH = 128;

/** Count Unicode code points, matching the server-side password policy. */
export function passwordCodePointLength(password: string): number {
  return Array.from(password).length;
}

/**
 * Client-safe length boundary shared with the Worker. Common/expected-password
 * blocking remains server-side so the deny list is not shipped to browsers.
 */
export function passwordLengthMeetsPolicy(password: string): boolean {
  const length = passwordCodePointLength(password);
  return length >= PASSWORD_MIN_LENGTH && length <= PASSWORD_MAX_LENGTH;
}

export const PASSWORD_LENGTH_HELP = `至少 ${PASSWORD_MIN_LENGTH} 个字符，最长 ${PASSWORD_MAX_LENGTH} 个字符；可使用空格、符号和 Unicode，不要求固定字符组合。`;
